import { render, staticRenderFns } from "./JSBCDemo.vue?vue&type=template&id=1ee4436f&scoped=true"
import script from "./JSBCDemo.vue?vue&type=script&lang=js"
export * from "./JSBCDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee4436f",
  null
  
)

export default component.exports